import { render, staticRenderFns } from "./pay-slips-pdf.vue?vue&type=template&id=edc2686c&"
import script from "./pay-slips-pdf.vue?vue&type=script&lang=js&"
export * from "./pay-slips-pdf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports